import { render } from "./person-vehicle-detail.vue?vue&type=template&id=346acbc4"
import script from "./person-vehicle-detail.vue?vue&type=script&lang=js"
export * from "./person-vehicle-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__